module.exports = __webpack_public_path__ + "img/objects.dab4edc4.png";